import { z } from "zod";
import { MethodsInputSchema } from "./MethodsInput";

export const CreateMethodsInputRequestSchema = MethodsInputSchema.pick({
  name: true,
  exploitationFlow: true,
  testFlow: true,
  flowM3Day: true,
  flowM3Hour: true,
  hydrostaticLevel: true,
  hydrodynamicLevel: true,
  transmissivity: true,
  hydraulicConductivity: true,
  hydraulicGradient: true,
  effectivePorosity: true,
  storageCoefficient: true,
  recharge: true,
  saturatedThickness: true,
  saturatedThicknessTop: true,
  saturatedThicknessBase: true,
  aquiferType: true,
});

export type CreateMethodsInputRequest = z.infer<typeof CreateMethodsInputRequestSchema>;
